import { getEntityRef } from "@client/content/lib/helper";
import { makeModuleApiInfoSelector } from "@client/content/selectors";
import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { type AppState } from "@client/types";
import appInfo from "@common/appInfo";
import { addPost, backToPosts, confirmActiveAction, setActiveAction } from "../actions";
import { localStateSelector, makeForumOptionsSelector } from "../selectors";
import { type Forums } from "../types";
import Component, { type ActionProps, type MapProps } from "./component";

const makeMapStateToProps = () => {
  const apiInfoSelector = makeModuleApiInfoSelector();
  const forumOptionsSelector = makeForumOptionsSelector();

  return (state: AppState, props: RootContainerProps): MapProps => {
    const localState = localStateSelector(state, props);

    return {
      ...props,
      activeAction: localState.activeAction,
      apiInfo: apiInfoSelector(state, props),
      item: localState.posts.find((x) => x.ticketId === localState.showingPostId)!,
      forumOptions: forumOptionsSelector(state, props),
      status: localState.status,
      userId: appInfo.user?.id
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: RootContainerProps): ActionProps => ({
  onCancelAction: () => dispatch(setActiveAction(getEntityRef(props), null)),
  onConfirmAction: (data?: any) => dispatch(confirmActiveAction({ ...getEntityRef(props), data })),
  onBack: () => dispatch(backToPosts(getEntityRef(props))),
  onDeleteClick: (ticketId: string) =>
    dispatch(setActiveAction(getEntityRef(props), { target: "post", type: "delete", targetId: ticketId })),
  onSubmit: (data: Forums.View.AddEditPost) => dispatch(addPost(getEntityRef(props), data)),
  onReplyCommentClick: (ticketCommentId: string) =>
    dispatch(
      setActiveAction(
        getEntityRef(props),
        ticketCommentId ? { target: "comment", type: "reply", targetId: ticketCommentId } : null
      )
    ),
  onUpdateClick: (ticketId: string) =>
    dispatch(setActiveAction(getEntityRef(props), { target: "post", type: "update", targetId: ticketId })),
  onUpdateCommentClick: (ticketCommentId: string) =>
    dispatch(setActiveAction(getEntityRef(props), { target: "comment", type: "update", targetId: ticketCommentId }))
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
